<div class="header">
  <h1 class="header__title">{{ data.title | translate }}</h1>
  <mat-icon class="header__close" mat-dialog-close>close</mat-icon>
</div>
<p class="description">{{ data.description | translate }}</p>
<p *ngIf="data.callToAction" class="description">{{ data.callToAction | translate }}</p>
<iframe
  title="YouTube video player"
  [src]="videoUrl"
  width="640"
  height="360"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowfullscreen
></iframe>
<div *ngIf="data.footer?.enabled" class="footer">
  <button
    *ngFor="let button of data.footer?.buttons"
    (click)="button.action()"
    class="footer__button {{ button.color }}"
    type="button"
  >
    {{ button.text | translate }}
  </button>
</div>
